export const startValueForX = {
  8: 0,
  7: 9,
  6: 18,
  5: 29,
  4: 40,
  3: 51,
  2: 62,
  1: 71,
};

export const startValueForY = {
  1: 0,
  2: 9,
  3: 18,
  4: 32,
  5: 46,
  6: 60,
  7: 74,
  8: 88,
  9: 102,
  0: 111,
};
